import Spinner from '../components/Spinner';

const LoadingScene = () => {
  return (
    <div id='primer-checkout-scene-loading' class='PrimerCheckout__scene'>
      <Spinner />
    </div>
  );
};

export default LoadingScene;
